<template>
    <transition name="modal-slide">
        <div v-if="isdisplay" class="modal-overlay" @click.self="close">
            <div class="modal-container">
                <!-- Header -->
                <header class="modal-header">
                    <div class="header-left">
                        <div class="header-icon">
                            <svg v-if="typedoc === 'cat'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                            </svg>
                            <svg v-else-if="typedoc === 'unite'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                            </svg>
                            <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                                <line x1="12" y1="22.08" x2="12" y2="12"/>
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2 class="modal-title">{{ titlemodal }}</h2>
                            <p class="modal-subtitle">{{ filterdatatable.length }} élément(s) trouvé(s)</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="btn-close" aria-label="Fermer">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                    </button>
                </header>

                <!-- Search & Actions Bar -->
                <div class="toolbar">
                    <div class="search-container">
                        <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="11" cy="11" r="8"/>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                        </svg>
                        <input
                                v-model="searchword"
                                type="text"
                                class="search-input"
                                placeholder="Rechercher..."
                                @focus="searchFocused = true"
                                @blur="searchFocused = false"
                        >
                        <button v-if="searchword" @click="searchword = ''" class="search-clear">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <circle cx="12" cy="12" r="10"/>
                                <line x1="15" y1="9" x2="9" y2="15"/>
                                <line x1="9" y1="9" x2="15" y2="15"/>
                            </svg>
                        </button>
                    </div>
                    <button @click="btnajouter" class="btn-add">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="12" y1="5" x2="12" y2="19"/>
                            <line x1="5" y1="12" x2="19" y2="12"/>
                        </svg>
                        <span class="btn-add-text">Ajouter</span>
                    </button>
                </div>

                <!-- Body Content -->
                <main class="modal-body">
                    <!-- Liste des éléments -->
                    <div class="list-container">
                        <template v-if="filterdatatable.length">
                            <div
                                    v-for="(datavalue, index) in filterdatatable"
                                    :key="index"
                                    @click="selected(datavalue)"
                                    class="list-item"
                            >
                                <div class="item-index">{{ index + 1 }}</div>
                                <div class="item-content">
                                    <span class="item-name">{{ datavalue.name }}</span>
                                    <span v-if="datavalue.description" class="item-description">{{ datavalue.description }}</span>
                                </div>
                                <div class="item-action">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <polyline points="9 18 15 12 9 6"/>
                                    </svg>
                                </div>
                            </div>
                        </template>

                        <!-- Empty State -->
                        <div v-else class="empty-state">
                            <div class="empty-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                                    <circle cx="12" cy="12" r="10"/>
                                    <path d="M16 16s-1.5-2-4-2-4 2-4 2"/>
                                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                                </svg>
                            </div>
                            <h3 class="empty-title">Aucun résultat</h3>
                            <p class="empty-text">
                                <template v-if="searchword">
                                    Aucun élément ne correspond à "{{ searchword }}"
                                </template>
                                <template v-else>
                                    La liste est vide. Ajoutez un nouvel élément.
                                </template>
                            </p>
                            <button v-if="!searchword" @click="btnajouter" class="btn-empty-add">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <line x1="12" y1="5" x2="12" y2="19"/>
                                    <line x1="5" y1="12" x2="19" y2="12"/>
                                </svg>
                                Ajouter un élément
                            </button>
                        </div>
                    </div>
                </main>

                <!-- Pagination -->
                <div v-if="pages.length > 1" class="pagination-container">
                    <div class="pagination-info">
                        Page {{ page }} sur {{ pages.length }}
                    </div>
                    <div class="pagination-controls">
                        <button
                                @click="page--"
                                :disabled="page <= 1"
                                class="pagination-btn"
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="15 18 9 12 15 6"/>
                            </svg>
                        </button>

                        <div class="pagination-pages">
                            <button
                                    v-for="(pageNumber, key) in displayedPages"
                                    :key="key"
                                    @click="pageNumber !== '...' && (page = pageNumber)"
                                    :class="['pagination-page', {
                  'active': pageNumber === page,
                  'dots': pageNumber === '...'
                }]"
                                    :disabled="pageNumber === '...'"
                            >
                                {{ pageNumber }}
                            </button>
                        </div>

                        <button
                                @click="page++"
                                :disabled="page >= pages.length"
                                class="pagination-btn"
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <polyline points="9 18 15 12 9 6"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- Footer -->
                <footer class="modal-footer">
                    <button @click="selected(null)" class="btn btn-clear">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M3 6h18"/>
                            <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                            <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                        </svg>
                        <span>Effacer la sélection</span>
                    </button>
                    <button @click="close" class="btn btn-close-footer">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"/>
                            <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                        <span>Fermer</span>
                    </button>
                </footer>
            </div>
        </div>
    </transition>

    <!-- Sub Modal Form -->
    <modalform @closed="loadreturnotherdata" ref="modalform"></modalform>
</template>

<script>
    import modalform from "@/components/views/pages/definition/fichiersdebase/form";
    import { randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",

        components: {
            modalform
        },

        watch: {
            searchword: function(newvalue, oldvalue) {
                this.page = 1;
            },
            searchtrierletableau: function(newvalue, oldvalue) {
                this.page = 1;
            }
        },

        computed: {
            displayedPages() {
                const start = Math.max(1, this.page - 2);
                const end = Math.min(this.pages.length, start + 4);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },

            filterdatatable() {
                let mvalue = this.datatable;
                this.perPage = this.DefaultperPage;

                if (this.searchword !== '') {
                    let t = this;
                    mvalue = mvalue.filter(function(post) {
                        return post.name.toLowerCase().includes(t.searchword.toLowerCase());
                    });
                }

                return this.paginate(mvalue);
            }
        },

        data() {
            return {
                isdisplay: false,
                titlemodal: "",
                datatable: [],
                typedoc: "",
                messageerror: "",
                messagesucces: "",
                searchword: "",
                searchtrierletableau: "",
                searchFocused: false,
                posts: [''],
                page: 1,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: []
            };
        },

        methods: {
            close() {
                this.isdisplay = false;
            },

            selected(datavalue) {
                const elementSelectionne = {
                    typ: this.typedoc,
                    value: datavalue,
                    datatable: this.datatable
                };

                this.$emit('elementSelectionnefichierdebase', elementSelectionne);
                this.isdisplay = false;
            },

            btnajouter() {
                let mname;
                let Item = {
                    pid: '',
                    intitule: '',
                    typ: this.typedoc,
                    taux: 0,
                    typreg: "CAISSE",
                    qteengros: 0,
                    qteendetail: 0
                };

                if (this.typedoc === 'cat') {
                    mname = 'Enregistrer un Catalogue';
                }

                if (this.typedoc === 'unite') {
                    mname = 'Enregistrer une unité';
                }

                if (this.typedoc === 'emballage') {
                    mname = 'Enregistrer un emballage';
                    Item = {
                        pid: '',
                        intitule: '',
                        typ: this.typedoc,
                        taux: 0,
                        typreg: "",
                        qteengros: 1,
                        qteendetail: 0
                    };
                }

                this.$refs.modalform.show(mname, "add", this.typedoc, Item);
            },

            show(titlemodal, listdata, typedoc) {
                this.messagesucces = "";
                this.messageerror = "";
                this.titlemodal = titlemodal;
                this.datatable = listdata;
                this.typedoc = typedoc;
                this.searchword = "";
                this.page = 1;
                this.isdisplay = true;
            },

            async loadreturnotherdata() {
                const t = this;
                let url = process.env.VUE_APP_API_URL + '/ar85474524otherdatadofodfidfoioienf55485/' + this.$store.state.appsociete + '/' + randomString();

                try {
                    const res = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    t.$store.dispatch('lancerchargement', false);

                    if (res.data.success) {
                        if (t.typedoc === 'cat') {
                            t.datatable = [];
                            t.datatable = res.data.otherdata.catalogue;
                        }

                        if (t.typedoc === 'unite') {
                            t.datatable = [];
                            t.datatable = res.data.otherdata.unite;
                        }

                        if (t.typedoc === 'emballage') {
                            t.datatable = [];
                            t.datatable = res.data.otherdata.emballage;
                        }
                    } else {
                        t.datatable = [];
                    }
                } catch (error) {
                    t.$store.dispatch('lancerchargement', false);
                } finally {
                    t.$store.dispatch('lancerchargement', false);
                }
            },

            setPages(posts) {
                this.pages = [];
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            },

            paginate(posts) {
                this.setPages(posts);
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res = posts.slice(from, to);

                if ($res.length > 0) {
                    return $res;
                } else {
                    return posts;
                }
            }
        }
    };
</script>

<style scoped>
    /* ========================================
       Variables CSS - Design System
       ======================================== */
    .modal-overlay {
        /* Charte cf-/ds- : marque Ynex (#845ADF) + neutres cf (voir form.vue) */
        --primary: #845ADF;
        --primary-hover: #7349cc;
        --primary-light: #ece7fb;
        --primary-dark: #5b39b0;
        --success: #26bf94;
        --success-light: #d7f5ec;
        --danger: #e6533c;
        --danger-light: #fdecea;
        --warning: #f5b849;
        --bg-primary: #ffffff;
        --bg-secondary: var(--cf-surface);
        --bg-tertiary: var(--cf-surface-alt);
        --bg-hover: var(--cf-border);
        --text-primary: var(--cf-ink-strong);
        --text-secondary: var(--cf-muted);
        --text-muted: var(--cf-faint);
        --border: var(--cf-border);
        --shadow: var(--cf-shadow-md);
        --shadow-sm: var(--cf-shadow-sm);
        --radius: var(--cf-radius);
        --radius-md: var(--cf-radius-sm);
        --radius-sm: var(--cf-radius-sm);
    }

    /* ========================================
       Modal Overlay
       ======================================== */
    .modal-overlay {
        position: fixed;
        inset: 0;
        z-index: 50;
        background: rgba(15, 23, 42, 0.7);
        backdrop-filter: blur(4px);
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 0;
    }

    @media (min-width: 768px) {
        .modal-overlay {
            align-items: center;
            padding: 1.5rem;
        }
    }

    /* ========================================
       Modal Container
       ======================================== */
    .modal-container {
        background: var(--bg-primary);
        width: 100%;
        max-width: 100%;
        height: 90vh;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        border-radius: var(--radius) var(--radius) 0 0;
        box-shadow: var(--shadow);
        overflow: hidden;
        animation: slideUp 0.3s ease-out;
    }

    @media (min-width: 768px) {
        .modal-container {
            max-width: 600px;
            height: auto;
            max-height: 80vh;
            border-radius: var(--radius);
            animation: fadeScale 0.25s ease-out;
        }
    }

    @keyframes slideUp {
        from {
            transform: translateY(100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    @keyframes fadeScale {
        from {
            transform: scale(0.95) translateY(20px);
            opacity: 0;
        }
        to {
            transform: scale(1) translateY(0);
            opacity: 1;
        }
    }

    /* ========================================
       Modal Header
       ======================================== */
    .modal-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 1.25rem;
        border-bottom: 1px solid var(--border);
        background: var(--bg-primary);
        flex-shrink: 0;
    }

    .header-left {
        display: flex;
        align-items: center;
        gap: 0.875rem;
    }

    .header-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.75rem;
        height: 2.75rem;
        background: var(--primary-light);
        border-radius: var(--radius-sm);
        color: var(--primary);
    }

    .header-icon svg {
        width: 1.5rem;
        height: 1.5rem;
    }

    .header-text {
        display: flex;
        flex-direction: column;
    }

    .modal-title {
        font-size: 1.125rem;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
        line-height: 1.3;
    }

    .modal-subtitle {
        font-size: 0.75rem;
        color: var(--text-muted);
        margin: 0.125rem 0 0;
    }

    .btn-close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.5rem;
        height: 2.5rem;
        border: none;
        background: var(--bg-secondary);
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s ease;
        color: var(--text-secondary);
    }

    .btn-close:hover {
        background: var(--danger-light);
        color: var(--danger);
    }

    .btn-close svg {
        width: 1.25rem;
        height: 1.25rem;
    }

    /* ========================================
       Toolbar (Search + Add)
       ======================================== */
    .toolbar {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.875rem 1.25rem;
        background: var(--bg-secondary);
        border-bottom: 1px solid var(--border);
        flex-shrink: 0;
    }

    .search-container {
        flex: 1;
        position: relative;
        display: flex;
        align-items: center;
    }

    .search-icon {
        position: absolute;
        left: 0.875rem;
        width: 1.125rem;
        height: 1.125rem;
        color: var(--text-muted);
        pointer-events: none;
        transition: color 0.2s ease;
    }

    .search-container:focus-within .search-icon {
        color: var(--primary);
    }

    .search-input {
        width: 100%;
        padding: 0.625rem 2.5rem 0.625rem 2.75rem;
        font-size: 0.9375rem;
        border: 2px solid var(--border);
        border-radius: var(--radius-sm);
        background: var(--bg-primary);
        color: var(--text-primary);
        transition: all 0.2s ease;
        outline: none;
    }

    .search-input:focus {
        border-color: var(--primary);
        box-shadow: 0 0 0 3px var(--primary-light);
    }

    .search-input::placeholder {
        color: var(--text-muted);
    }

    .search-clear {
        position: absolute;
        right: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.75rem;
        height: 1.75rem;
        border: none;
        background: transparent;
        border-radius: 50%;
        cursor: pointer;
        color: var(--text-muted);
        transition: all 0.2s ease;
    }

    .search-clear:hover {
        background: var(--bg-hover);
        color: var(--text-primary);
    }

    .search-clear svg {
        width: 1rem;
        height: 1rem;
    }

    .btn-add {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.375rem;
        padding: 0.625rem 1rem;
        font-size: 0.875rem;
        font-weight: 600;
        border: none;
        background: var(--primary);
        color: white;
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s ease;
        white-space: nowrap;
    }

    .btn-add:hover {
        background: var(--primary-hover);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    }

    .btn-add:active {
        transform: translateY(0);
    }

    .btn-add svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    .btn-add-text {
        display: none;
    }

    @media (min-width: 480px) {
        .btn-add-text {
            display: inline;
        }
    }

    /* ========================================
       Modal Body (List)
       ======================================== */
    .modal-body {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        background: var(--bg-primary);
    }

    .list-container {
        padding: 0.5rem 0;
    }

    .list-item {
        display: flex;
        align-items: center;
        gap: 0.875rem;
        padding: 0.875rem 1.25rem;
        cursor: pointer;
        transition: all 0.15s ease;
        border-bottom: 1px solid var(--bg-tertiary);
    }

    .list-item:hover {
        background: var(--bg-secondary);
    }

    .list-item:active {
        background: var(--primary-light);
    }

    .item-index {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 2rem;
        height: 2rem;
        font-size: 0.75rem;
        font-weight: 600;
        color: var(--text-muted);
        background: var(--bg-tertiary);
        border-radius: 50%;
    }

    .item-content {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 0.125rem;
    }

    .item-name {
        font-size: 0.9375rem;
        font-weight: 500;
        color: var(--text-primary);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .item-description {
        font-size: 0.8125rem;
        color: var(--text-muted);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .item-action {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5rem;
        height: 1.5rem;
        color: var(--text-muted);
        opacity: 0;
        transform: translateX(-4px);
        transition: all 0.2s ease;
    }

    .list-item:hover .item-action {
        opacity: 1;
        transform: translateX(0);
    }

    .item-action svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    /* ========================================
       Empty State
       ======================================== */
    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 3rem 1.5rem;
        text-align: center;
    }

    .empty-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 4.5rem;
        height: 4.5rem;
        background: var(--bg-tertiary);
        border-radius: 50%;
        margin-bottom: 1.25rem;
        color: var(--text-muted);
    }

    .empty-icon svg {
        width: 2.5rem;
        height: 2.5rem;
    }

    .empty-title {
        font-size: 1.125rem;
        font-weight: 600;
        color: var(--text-primary);
        margin: 0 0 0.5rem;
    }

    .empty-text {
        font-size: 0.875rem;
        color: var(--text-muted);
        margin: 0 0 1.5rem;
        max-width: 280px;
    }

    .btn-empty-add {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.25rem;
        font-size: 0.875rem;
        font-weight: 600;
        border: 2px dashed var(--primary);
        background: var(--primary-light);
        color: var(--primary);
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .btn-empty-add:hover {
        background: var(--primary);
        color: white;
        border-style: solid;
    }

    .btn-empty-add svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    /* ========================================
       Pagination
       ======================================== */
    .pagination-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75rem 1.25rem;
        background: var(--bg-secondary);
        border-top: 1px solid var(--border);
        flex-shrink: 0;
    }

    .pagination-info {
        font-size: 0.8125rem;
        color: var(--text-muted);
        display: none;
    }

    @media (min-width: 480px) {
        .pagination-info {
            display: block;
        }
    }

    .pagination-controls {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        margin: 0 auto;
    }

    @media (min-width: 480px) {
        .pagination-controls {
            margin: 0;
        }
    }

    .pagination-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.25rem;
        height: 2.25rem;
        border: 1px solid var(--border);
        background: var(--bg-primary);
        border-radius: var(--radius-sm);
        cursor: pointer;
        color: var(--text-secondary);
        transition: all 0.2s ease;
    }

    .pagination-btn:hover:not(:disabled) {
        background: var(--bg-hover);
        border-color: var(--primary);
        color: var(--primary);
    }

    .pagination-btn:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    .pagination-btn svg {
        width: 1rem;
        height: 1rem;
    }

    .pagination-pages {
        display: flex;
        align-items: center;
        gap: 0.25rem;
    }

    .pagination-page {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 2.25rem;
        height: 2.25rem;
        padding: 0 0.5rem;
        font-size: 0.8125rem;
        font-weight: 500;
        border: 1px solid transparent;
        background: transparent;
        border-radius: var(--radius-sm);
        cursor: pointer;
        color: var(--text-secondary);
        transition: all 0.2s ease;
    }

    .pagination-page:hover:not(:disabled):not(.active) {
        background: var(--bg-hover);
    }

    .pagination-page.active {
        background: var(--primary);
        color: white;
        font-weight: 600;
    }

    .pagination-page.dots {
        cursor: default;
        color: var(--text-muted);
    }

    /* ========================================
       Modal Footer
       ======================================== */
    .modal-footer {
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.25rem;
        border-top: 1px solid var(--border);
        background: var(--bg-primary);
        flex-shrink: 0;
    }

    .btn {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        padding: 0.75rem 1rem;
        font-size: 0.875rem;
        font-weight: 600;
        border: none;
        border-radius: var(--radius-sm);
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .btn svg {
        width: 1.125rem;
        height: 1.125rem;
    }

    .btn-clear {
        background: var(--success-light);
        color: var(--success);
        border: 1px solid transparent;
    }

    .btn-clear:hover {
        background: var(--success);
        color: white;
    }

    .btn-close-footer {
        background: var(--bg-tertiary);
        color: var(--text-secondary);
    }

    .btn-close-footer:hover {
        background: var(--danger-light);
        color: var(--danger);
    }

    /* ========================================
       Transitions
       ======================================== */
    .modal-slide-enter-active,
    .modal-slide-leave-active {
        transition: all 0.3s ease;
    }

    .modal-slide-enter-from,
    .modal-slide-leave-to {
        opacity: 0;
    }

    .modal-slide-enter-from .modal-container,
    .modal-slide-leave-to .modal-container {
        transform: translateY(100%);
    }

    @media (min-width: 768px) {
        .modal-slide-enter-from .modal-container,
        .modal-slide-leave-to .modal-container {
            transform: scale(0.95) translateY(20px);
        }
    }

    /* ========================================
       Scrollbar Custom
       ======================================== */
    .modal-body::-webkit-scrollbar {
        width: 6px;
    }

    .modal-body::-webkit-scrollbar-track {
        background: transparent;
    }

    .modal-body::-webkit-scrollbar-thumb {
        background: var(--border);
        border-radius: 3px;
    }

    .modal-body::-webkit-scrollbar-thumb:hover {
        background: var(--text-muted);
    }
</style>